import { c as _c } from "react/compiler-runtime";
import { IcoCopy16 } from '@onefootprint/icons';
import { Dropdown, useToast } from '@onefootprint/ui';
import { useTranslation } from 'react-i18next';
type CopyIdProps = {
  id: string;
  onClick: () => void;
};
const CopyId = t0 => {
  const $ = _c(11);
  const {
    id,
    onClick
  } = t0;
  const {
    toast
  } = useToast();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "edit.copyNodeId"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("playbook-builder", t1);
  let t2;
  if ($[1] !== id || $[2] !== onClick || $[3] !== t || $[4] !== toast) {
    t2 = () => {
      onClick();
      navigator.clipboard.writeText(id);
      toast({
        title: t(_temp),
        description: id
      });
    };
    $[1] = id;
    $[2] = onClick;
    $[3] = t;
    $[4] = toast;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const handleCopy = t2;
  let t3;
  if ($[6] !== t) {
    t3 = t(_temp2);
    $[6] = t;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== handleCopy || $[9] !== t3) {
    t4 = <Dropdown.Item iconLeft={IcoCopy16} onSelect={handleCopy}>{t3}</Dropdown.Item>;
    $[8] = handleCopy;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
};
export default CopyId;
function _temp($) {
  return $.toast.title;
}
function _temp2($_0) {
  return $_0.label;
}